import React from 'react';
import { Text, Stack, Icon } from '@servicetitan/design-system';

export const DocumentListEmptyMessage: React.FC = () => (
    <Stack justifyContent="space-between" className="m-t-1 m-b-2">
        <Stack.Item alignSelf="center">
            <Icon name="check_circle" size={28} className="c-neutral-70" />
        </Stack.Item>
        <Stack.Item className="w-100 p-x-2" shrink={1} alignSelf="center">
            <Text el="span" size="1" className="c-neutral-90">
                No new documents to sign, you are up to date.
            </Text>
        </Stack.Item>
    </Stack>
);
